import { ColumnVisibility } from "./types";

export const DATA_TEST_IDS = {
  TRANSACTIONS_SCREEN: "transactions-screen",
  TRANSACTIONS_SCREEN_HEADER: "transactions-screen-header",
  TRANSACTIONS_SCREEN_BODY: "transactions-screen-body",
  TRANSACTIONS_SCREEN_PANEL: "transactions-screen-panel",
  TRANSACTIONS_TAB_ALL: "transactions-tab-all",
  TRANSACTIONS_TAB_RULES: "transactions-tab-rules",
  TRANSACTIONS_TABLE: "transactions-table",
  IMPORT_TRANSACTIONS_BUTTON: "import-transactions-button",
  TRANSACTIONS_TABLE_TOP_TOOLBAR: "transactions-table-top-toolbar",
  TRANSACTIONS_TABLE_BOTTOM_TOOLBAR: "transactions-table-bottom-toolbar",
  PAYMENT_PROCESSOR_TAB_SUMMARY: "payment-processor-tab-summary",
  PAYMENT_PROCESSOR_TAB_DETAIL: "payment-processor-tab-detail",
  PAYMENT_PROCESSOR_TAB_RECONCILIATIONS: "payment-processor-tab-reconciliations",
};

export const DEFAULT_PAGE_SIZE = 25;

export const MOUSE_HOVER_CLASSNAME = "mouseHoverable";
export const KBD_HOVER_CLASSNAME = "kbd-hover";
export const DEFAULT_COLUMN_ORDER = [
  "mrt-row-select", // the select checkbox
  "date",
  "available_on_date",
  "vendor_customer",
  "amount",
  "descriptor",
  "category",
  "status",

  "account",
  "department",
  "location",
  "classes",
  "classifications",
];

export const TRANSACTION_COLUMN_HEADER_MAP = {
  account: "Source",
  amount: "Amount",
  assignee: "Assignee",
  available_on_date: "Available Date",
  category: "Category",
  classes: "Classes",
  classifications: "Classifications",
  date: "Transaction Date",
  department: "Department",
  descriptor: "Description",
  location: "Location",
  status: "Status",
  vendor_customer: "Vendor/Customer",
};

export const DEFAULT_COLUMN_VISIBILITY: ColumnVisibility = {
  account: false, // Source
  amount: true,
  assignee: false,
  category: true,
  classes: false,
  classifications: false,
  date: true,
  department: false,
  descriptor: true, // Description
  location: false,
  status: true,
  vendor_customer: true,
};

// TODO: Do we have app configs?
// imo (TG): it would be best if we could control these values on the server
export const CAPITALIZABLE_TXN_AMOUNT_THRESHOLD = 2500;

// TODO: Do we have app configs?
// imo (TG): it would be best if we could control these values on the server
// imo (PS): This logic shouldn't be on the client.
// The client should ask GW if we should go through additional steps.
// This could happen in recategorizeTransaction or as a separate query.
export const CAPITALIZABLE_CATEGORIES = ["computers_and_hardware", "furniture", "fixed_assets"];
